<template>
  <div class="lc-msg-page">
    <div class="lc-msg-dialog" v-for="(item,index) in dataList" @touchstart.prevent='touchStart($event)'
         @touchend.prevent='touchEnd($event,item)'>
      <img :src="item.lcMsg.convType==1?actNotification:item.lcMsg.awayAvatar" alt="" class="avatar"
           :onerror="errorAvatar">
      <div class="content-panel">
        <div class="name" v-text="item.lcMsg.convType==1?'Activity':item.lcMsg.awayNickname"></div>
        <div class="msg" v-text="item.lcMsg.content"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import icondefaulthead from "../../assets/imgs/icon_default_head.png";
  import actNotification from '../../assets/imgs/activity-notification.png'
  import IMManager from "../../im/IMManager";
  import {hideDialog, isnull, showDialog, Toast} from "../../utils/tools";
  import accountApi from "../../api/account-api";
  import TipsUtils from "../../utils/TipsUtils";
  import router from "../../router";
  import EventBusConstant from "../../push/const/EventBusConstant";
  import global from "../../config/global";

  export default {
    name: "lcmessagedialog",
    props: {
      newLcMsgList: {
        type: Array,
        default: new Array(),
        startX: 0,
        startY: 0,
        nextTime: null,
      },
    },
    data() {
      return {
        dataList: [],
        actNotification,
        errorAvatar: 'this.src="' + icondefaulthead + '"',
      }
    },
    methods: {
      // 向左滚动代码
      clearNextTim() {
        for (let i = 0; i < this.dataList.length; i++) {
          let tmp = this.dataList[i];
          clearTimeout(tmp.nextTimer)
          this.removeLCMsg(tmp)
        }
        this.dataList = []
      },
      touchStart(ev) {
        ev = ev || event
        //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
        if (ev.touches.length == 1) {
          // 记录开始位置
          this.startX = ev.touches[0].clientX;
          this.startY = ev.touches[0].clientY;
        }
      },
      removeLCMsg(item){
        this.$emit('removeLCMsg',item)
      },
      // touchMove(ev){
      //   ev = ev || event;
      //   //获取删除按钮的宽度，此宽度为滑块左滑的最大距离
      //   let wd=this.$refs.remove.offsetWidth;
      //   if(ev.touches.length == 1) {
      //     // 滑动时距离浏览器左侧实时距离
      //     this.moveX = ev.touches[0].clientX
      //     //起始位置减去 实时的滑动的距离，得到手指实时偏移距离
      //     this.disX = this.startX - this.moveX;
      //     // 如果是向右滑动或者不滑动，不改变滑块的位置
      //     if(this.disX < 0 || this.disX == 0) {
      //       this.deleteSlider = "transform:translateX(0px)";
      //       // 大于0，表示左滑了，此时滑块开始滑动
      //     }else if (this.disX > 0) {
      //       //this.$store.state.left_tuoch_uid = this._uid  //滑动的时候改变vuex里的已滑动组件id
      //
      //       //具体滑动距离我取的是 手指偏移距离*5。
      //       this.deleteSlider = "transform:translateX(-" + this.disX*5 + "px)";
      //
      //       // 最大也只能等于删除按钮宽度
      //       if (this.disX*5 >=wd) {
      //         this.deleteSlider = "transform:translateX(-" +wd+ "px)";
      //
      //       }
      //     }
      //   }
      // },
      touchEnd(ev, item) {
        ev = ev || event;
        if (ev.changedTouches.length == 1) {
          let endX = ev.changedTouches[0].clientX;
          let endY = ev.changedTouches[0].clientY;
          let disX = this.startX - endX;
          let disY = this.startY - endY;
          console.log('lcMsg-dff[' + disX + ',' + disY + ']')
          // console.log(this.disX)
          //如果距离小于删除按钮一半,强行回到起点
          if (disY >= 20) {
            this.clearNextTim()
          } else if (disY >= 0 && disY < 20 && Math.abs(disX) < 40) {
            this.toChatRoom(item.lcMsg)
          }
        }
      },
      toChatRoom(msg) {
        if (['/svc/call', '/svc/callec'].indexOf(this.$route.path) != -1) {
          return;
        }
        if (!IMManager.hasClient(this)) {
          Toast.error('Please  check your network to continue.', this)
          return
        }
        showDialog(this)
        accountApi.getAnchorInfo(msg.awayAccountId, function (data, page) {
          page.doSkipChat(msg, data)
        }, function (code, msg, page) {
          hideDialog(page)
          Toast.error(TipsUtils.getErrorTips(code), page)
        }, this, false, false)

      }
      ,
      doSkipChat(convMsg, user) {
        hideDialog()
        let target = this

        target.dataList.splice(0, target.dataList.length)
        let path = {
          name: 'ChatRoom',
          params: {
            acc: convMsg.awayAccountId,
            user: user,
            convId: convMsg.conversationId,
            convType: convMsg.convType,
            fromChatLV: false
          }
        }
        if (target.$route.path == '/conv/chat')
          target.$EventBus.$emit(EventBusConstant.EVENT_CHAT_ROOM_REFRESH, path.params)
        else {
          global.skipFromLCMsg = true
          router.togo(path)
        }

      },
      removeAll() {
        this.dataList.splice(0, this.dataList.length)
      },
      removeMsg(item) {
        this.removeLCMsg(item)
        let index = this.findIndexByUid(item)
        if (index != -1)
          this.dataList.splice(index, 1)
      },
      findIndexByUid(item) {
        if (!isnull(item) && !isnull(this.dataList))
          for (let i = 0; i < this.dataList.length; i++) {
            let tmp = this.dataList[i]
            if (tmp.uid == item.uid)
              return i;
          }
        return -1;
      }
    },
    watch: {
      newLcMsgList(n, o) {
        if (!isnull(n)) {
          this.dataList=n;
          for (let i = 0; i < this.dataList.length; i++) {
            let tmp = this.dataList[i];
            if (!tmp.inShow) {
              tmp.inShow = true;
              let target = this;
              tmp.nextTimer = setTimeout(function () {
                target.removeMsg(tmp)
              }, tmp.time)
            }
          }
        }
      }
    },
    destroyed() {
      console.log('lcmessage dialog destroy')
    },
    created() {
      console.log('lcmessage dialog created')
    }, mounted() {
      console.log('lcmessage dialog mounted')
    }
  }
</script>

<style lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .lc-msg-page {
    position: fixed;
    z-index: 500;
    top: 0;
    .left(20);
    .right(20);
  }

  .lc-msg-dialog {
    position: absolute;
    .w(710);
    .h(158);
    .b-radius(0, 0, 52, 52);
    background: #fff;
    font-size: 0;
    text-align: left;
    transition: margin-top 1s;

    .avatar {
      .w(82);
      .h(82);
      .b-radius(41);
      display: inline-block;
      object-fit: cover;
      .mt(38);
      .ml(30);
    }

    .content-panel {
      .maxw(520);
      display: inline-block;
      .ml(30);
      .mt(-6);

      .name {
        .fs(32);
        font-family: Gilroy-Bold;
        color: #1E2028;
        max-lines: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .msg {
        .fs(28);
        .mt(12);
        font-family: Gilroy-Bold;
        color: #BAB3BD;
        max-lines: 1;
        max-lines: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/lcmessagedialog.vue